import {isEmpty} from 'lodash';
import React from 'react';

import {getEmojiStringForLanguageCode} from '../../../../../../../libs/shared/core/src/helpers/ai/composeV2Helpers';
import {
  AiSupportedLanguageCodesEnum,
  isAiSupportedLanguageCode,
} from '../../../../../../../libs/shared/core/src/helpers/ai/constants';
import {MessageTypesEnum} from '../../../../../../../libs/shared/core/src/models/api/commonMessageModel';
import {
  LoadedMessageModel,
  MessageVisualStatusesEnum,
} from '../../../../../../../libs/shared/core/src/models/api/messageModel';
import {emojiToDefinition} from '../../../../../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {baseEmojiValidationMap} from '../../../../../../services/emojis/emojis';
import {Emoji} from '../../../../../common/emoji/emoji';

export function renderEmojiForLanguageCode(languageCode: string) {
  const emojiString = getEmojiStringForLanguageCode(languageCode);
  const definition = emojiString && emojiToDefinition(emojiString, baseEmojiValidationMap);
  if (!definition) {
    return null;
  }

  return <Emoji emoji={definition.emoji} size={16} />;
}

export function shouldTranslateLanguage(
  message: LoadedMessageModel,
  preferredLanguages: ReadonlyArray<AiSupportedLanguageCodesEnum>,
): boolean {
  if (isEmpty(preferredLanguages)) {
    return false;
  }

  // Only emails to avoid rendering banners on many small messages.
  if (message.type !== MessageTypesEnum.EMAIL) {
    return false;
  }

  if (message.visualStatus !== MessageVisualStatusesEnum.TIMELINE) {
    return false;
  }

  if (!message.detectedLanguage || !isAiSupportedLanguageCode(message.detectedLanguage)) {
    return false;
  }

  return !preferredLanguages.includes(message.detectedLanguage);
}
